module.exports = __webpack_public_path__ + "static/media/image2.e475e9bd.png";